(function () {
    'use strict';

    var module = angular.module('app.directives');
    module.directive('swaggerParamType', [function () {
        var directive = {
            restrict: 'E',
            transclude: true,
            replace:true,
            template: '<span class="bootstrap-label {{ labelClass }}" ng-transclude></label>',
            link: link,
            scope: {
                paramType:'='
            }
        };

        return directive;

        function link(scope, element, attrs) {
            var paramType = scope.paramType || '';
            switch (paramType) {
                case 'path':
                    scope.labelClass = 'label-warning';
                    break;
                case 'query':
                    scope.labelClass = 'label-primary';
                    break;
                case 'header':
                    scope.labelClass = 'label-success';
                    break;
                case 'body':
                    scope.labelClass = 'label-info';
                    break;
                case 'form':
                default:
                    scope.labelClass = 'label-default';
                    break;
            }
        }
    }]);
})();